"use client"

/*
==================================================
PAYMENT STEP

Функция:
шаг выбора способа оплаты внутри mobile cart modal

Родитель:
cart-mobile-body.tsx

Дочерние элементы:
Payment
ErrorMessage

Использует:
@modules/checkout/components/payment

Примечания:
именно этот шаг должен инициировать payment session
через стандартный компонент Medusa Payment
==================================================
*/

import { HttpTypes } from "@medusajs/types"

import ErrorMessage from "@modules/checkout/components/error-message"
import Payment from "@modules/checkout/components/payment"

type PaymentStepProps = {
  cart?: HttpTypes.StoreCart | null
  availablePaymentMethods?: HttpTypes.StorePaymentProvider[] | null
}

export default function PaymentStep({
  cart,
  availablePaymentMethods = [],
}: PaymentStepProps) {
  if (!cart) return null

  const hasPaymentMethods = Array.isArray(availablePaymentMethods)
    ? availablePaymentMethods.length > 0
    : false

  return (
    <div className="rounded-t-2xl border-x border-t border-slate-200 bg-white px-4 py-6 shadow-[0_4px_12px_rgba(15,23,42,0.2)]">
      <div className="mb-1 text-[1.05rem] font-extrabold tracking-[0.04em] text-slate-900">
        Payment method
      </div>

      <div className="mb-4 text-sm leading-6 text-slate-600">
        Choose how you would like to pay for your order
      </div>

      {!hasPaymentMethods ? (
        <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-500">
          Payment methods are not available yet.
        </div>
      ) : (
        <div className="rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-4">
          <Payment cart={cart} availablePaymentMethods={availablePaymentMethods} />
        </div>
      )}

      <div className="mt-4">
        <ErrorMessage error={null} data-testid="payment-step-error-message" />
      </div>
    </div>
  )
}
